

/*
	Source: htdocs/wim/js/core/src/Component.js
*/
(function($, wimbledonCore) {
var Component = function() {
        var id = 'Component';
        // eventsCore.setLogLevel('all');
        var logger = new eventsCore.util.Logger(id);
        var api = {};

        var overlay;
        var inline;
        var videoNextUp;

        var _types = {
            photo: 1,
            video: 2
        };

        var _platforms = {
            www: 1,
            app: 2
        };

        var _gallery_type = {
            dynamic: 1,
            gallery: 2
        };

        var _gallery_defaults = {
            type: 'photo',
            path: 'en_GB/xml/gen/galleries/mock.json',
            platform: 'www'
        };

        var _videoStore = {};
        var completeHandler;

        $(document).ready(function() {
            wimbledonCore.videoPlayer.on('CompleteEvent', onComplete);
            wimbledonCore.videoPlayer.on('PlayEvent', onPlay);
            wimbledonCore.videoPlayer.on('StartEvent', onStart);
            wimbledonCore.videoPlayer.on('RelatedEvent', onRelatedEvent);

            logger.info('Component - doc ready');

            $('.media_promo').on('click', function(e) {
                var id = $(this).parents('.content').attr('data-video-id');

                logger.info('Component - promo click - id:%o', id);

                if (id && id !== '') {
                    e.preventDefault();
                    var title = $(this).parents('.content').attr('data-video-title');
                    wimbledonCore.component.openVideoInline(id, title);
                    return false;
                }
            });
        })

        /**
         * handle play next callback
         */
        var onNextPlay = function(nextVideo) {
            if (nextVideo) {
                overlay.close(false);
                overlay.content.show();
                overlay.background.show();
                //logger.info('onNextPlay - video:%o', nextVideo);

                _videoStore[nextVideo.cmsId] = {
                    "id": nextVideo.cmsId,
                    "type": "vod",
                    "title": nextVideo.title,
                    "contentType": "",
                    "pictureM": nextVideo.thumb,
                    "wwwdash": "",
                    "wwwhlshigh": nextVideo.extradata.m3u8,
                    "pdl": "",
                    "preroll": nextVideo.extradata.preroll,
                    "link": nextVideo.extradata.share
                };

                overlay.load(nextVideo.cmsId, nextVideo.title, true);
            }
        }

        /**
         * handle video complete
         */
        var onComplete = function(data) {
            logger.info('onComplete - data:%o overlay:%o next:%o', data, overlay, videoNextUp);

            //parse id from data and compare to id in overlay or inline for processing

            try {
                if (overlay && overlay.curId() && videoNextUp) {
                    videoNextUp.getNext(overlay.curId(), onNextPlay);
                }

                if (inline && data.id.indexOf(inline.curId()) > -1) {
                    //inline.complete();
                    callCompleteHandler();
                }
            } catch (e) {
                logger.error('onComplete - error:%o', e);
            }
        };

        /**
         * call video complete handler passed into inline gallery
         *  - call stopPlaying to clear curId and allow for same video to be clicked
         */
        var callCompleteHandler = function() {
            if (completeHandler !== null && $.isFunction(completeHandler)){
                try{ 
                    stopPlayingVideo();
                    completeHandler.call(this, null);
                }
                catch(e){
                 
                }
            }
        };

        /**
         * handle video start
         */
        var onStart = function(data) {
            logger.info('onStart - data:%o', data);

            if (videoNextUp) {

            }
        };

        /**
         * handle video play
         */
        var onPlay = function(data) {
            logger.info('onPlay - data:%o', data);

            if (videoNextUp) {
                videoNextUp.cancel();
            }
        };

        /**
         * handle events from related content load
         */
        var onRelatedEvent = function(data) {
            if (data.error) {
                logger.error('onRelatedEvent - error getting content');
                overlay.showError('Error retrieving video information');
            }
        }

        /**
         * check for existing component with video
         */
        var getCurrentVideo = function() {
            if (overlay && overlay.curId()) {
                return overlay.curId();
            }
            else if (inline && inline.curId()){
                return inline.curId();
            }
            else {
                return false;
            }
        }

        var loadVideoGallery = function(container, path, platform) {
            logger.info('loading video gallery %o %s', container, path);
            var gallery = new Gallery(_types.video, container, path, platform);

            gallery.init();

            container.on('click.videogallery', '.video', function(e) {
                // handle how video would play
                var vidContent = $(this).parent();
                var videoId = vidContent.attr('data-video-id');
                var preRoll = false;
                if (vidContent.attr('data-preroll') !== undefined && vidContent.attr('data-preroll') === "true") {
                    preRoll = true;
                }

                if (platform === _platforms.www) {
                    var video = api.setVideoOverlay({
                        preroll: preRoll
                    });
                    video.load(videoId, vidContent.find('.title').text());
                } else if (platform === _platforms.app) {
                    inAppLink('video', {
                        id: videoId,
                        title: vidContent.find('.title').text(),
                        media: vidContent.attr('data-media'),
                        share: vidContent.attr('data-share')
                    });
                }

            });
        };

        var loadPhotoGallery = function(container, path, platform) {
            var gallery = new Gallery(_types.photo, container, path, platform);

            gallery.init();
        };

        var Gallery = function(type, container, path, platform) {
            var api = {};
            api.index = 0;
            api.max = -1;

            api.container = container;
            api.next = container.find('.next');
            api.prev = container.find('.prev');

            api.image = container.find('img');
            api.title = container.find('.title');
            api.date = container.find('.date');
            api.link = container.find('> a');

            var mPrefix = type === _types.photo ? 'Photo Gallery' : 'Video Gallery';

            var event = $('<div>');

            var cache = [];
            var template, objs;
            api.thumb_slider;
            var thumb_width = 105,
                thumb_margin = 7;

            function prefetchImage(img) {
                // prefetch images if they haven't previously been requested
                if (cache.indexOf(img) === -1) {
                    var cacheImage = document.createElement('img');
                    cacheImage.src = img;
                    cache.push(img);
                }
            }

            // assign actions
            api.container
                .on('click', '.next', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    nextItem();
                    measureApp(mPrefix, 'Next Gallery Item');
                    logger.info('clicking for next item in gallery');
                })
                .on('click', '.prev', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    prevItem();
                    measureApp(mPrefix, 'Previous Gallery Item');
                    logger.info('clicking for previous item in gallery');
                });

            // +template+ : Mustache template
            api.init = function() {
                logger.info('fetching gallery data from path ' + path);
                $.getJSON(path, function(data) {
                    objs = data.gallery_data;
                    api.max = objs.length - 1;

                    if (api.container.closest('.one-col').length === 0) {
                        loadThumbnails();
                    }

                    // load first image, assume title/date already written to page
                    loadItem(api.index);
                });
            }

            function loadThumbnails() {
                // append thumbnails to api.container
                var thumb_container = $('<div class="thumbnails"><div class="thumbwrapper"><ul class="thumbstrip"></ul></div><span class="prev"></span><span class="next"></span></div>');
                var thumb_list = thumb_container.find('ul');
                var thumb_tmpl = '<li class="thumbitem"><img src="{{thumb}}"></li>';
                Mustache.parse(thumb_tmpl);

                var lis = '';
                for (var i = 0, l = objs.length; i < l; i++) {
                    var elem = objs[i];
                    lis += Mustache.render(thumb_tmpl, elem);
                }
                thumb_list.html(lis);

                // update width so all lis are on one line
                thumb_list.css('width', l * (thumb_width + thumb_margin) - thumb_margin);

                // load image when clicking on thumbnail
                thumb_list.on('click', 'li', function(e) {
                    loadItem($(this).index());
                    measureApp(mPrefix, 'Load Gallery Item');
                });

                api.container.append(thumb_container);
                api.thumb_slider = thumb_list;

                // change what api.next, api.prev refer to
                api.next = api.next.add(thumb_container.find('.next'));
                api.prev = api.prev.add(thumb_container.find('.prev'));

                event.on('loaditem', function(e, num) {
                    // figure out distance from left edge that num will be
                    var dist = -1 * (thumb_width + thumb_margin) * num;
                    api.thumb_slider.css('transform', 'translate3d(' + dist + 'px,0px,0px)');
                    logger.info('setting translate3d to %spx', dist);

                    // change selected state of thumbnail
                    logger.info("mark slide %s active", num);
                    api.thumb_slider.find('li.thumbitem').removeClass('selected')
                        .eq(num).addClass('selected');
                });
            }

            // all encompassing catch for loading item in gallery
            function loadItem(num) {
                if (type === _types.photo) {
                    updateProperties(num, { image: 1, link: 1 });
                } else if (type === _types.video) {
                    updateProperties(num, { image: 1, "video-id": 1, media: 1, share: 1, title: 1, date: 1 });
                }

                api.index = num;
                updateArrowVisibility();

                // cache next image
                if (api.index < api.max) {
                    var cimg = objs[api.index + 1];
                    var file = getThumbImage(cimg.image);
                    prefetchImage(file);
                }

                event.trigger('loaditem', [num]);
            }

            // given file path to t_ thumbnail image
            // return larger w_ thumbnail image
            function getThumbImage(file) {
                var match = file.match(/thumbs\/t_(.*)$/);
                if (match !== null) {
                    file = file.replace(/\/t_(.*)$/, '/w_' + match[1]);
                }
                return file;
            }

            function updatePhotoSrc(num) {
                var item = objs[num];

                // find t_ image and replace with higher quality w_ image
                var file = item.image; // getThumbImage(item.thumb);

                // render template
                api.image.attr('src', file);
            }

            function updateProperties(num, props) {
                var item = objs[num];

                if (props['image']) {
                    api.image.attr('src', item.image);
                }
                if (type === _types.photo
                    && platform === _platforms.app
                    && _gallery_type[api.container.data('type')] === _gallery_type.dynamic
                    && props['link']) {
                    var path = item.image;
                    if(path.search('https?://') === -1) {
                        path = location.protocol + '//www.wimbledon.com' + path;
                    }
                    api.link.attr('href', 'javascript:inAppLink(\'photo\',{id:\'' + item.id + '\', url:\'' + path + '\'});');
                }
                if (props['video-id']) {
                    api.container.attr('data-video-id', item.id);
                }
                if (props['media']) {
                    api.container.attr('data-media', item.media);
                }
                if (props['share']) {
                    api.container.attr('data-share', item.share);
                }
                if (props['title']) {
                    api.title.html(item.title);
                }
                if (props['date']) {
                    api.date.html(item.date);
                }
            }

            function nextItem() {
                if (api.index < api.max) {
                    loadItem(api.index + 1);
                }
            }

            function prevItem() {
                if (api.index > 0) {
                    loadItem(api.index - 1);
                }
            }

            function updateArrowVisibility() {
                // hide appropriate arrows based on position in list
                api.next.removeClass('disabled');
                api.prev.removeClass('disabled');
                if (api.index === 0) {
                    api.prev.addClass('disabled');
                }
                if (api.index === api.max) {
                    api.next.addClass('disabled');
                }
            }

            return api;
        }

        /**
         * manage the video overlay element
         * @param prefix - CSS prefix that defines *Background and *Content element IDs
         * @param preroll - true/false whether a preroll should play before video
         */
        var VideoOverlay = function(prefix, preroll) {
            var desiredWidth = 966;
            var desiredHeight = 546;
            var videoWidth, videoHeight;
            var windowWidth, windowHeight;
            var curVideoId;

            var oapi = {};
            oapi.content = $('#' + prefix + 'Content');
            oapi.background = $('#' + prefix + 'Background');
            oapi.activePlayer;

            var _playerTypes = {
                ecp: 1,
                brightcove: 2,
                livit: 3
            };

            oapi.init = function() {
                // create elements if they don't exist
                if (oapi.background.length === 0) {
                    oapi.background = $('<div id="' + prefix + 'Background"></div>');
                    $('body').append(oapi.background);
                }
                if (oapi.content.length === 0) {
                    oapi.content = $(
                        '<div id="' + prefix + 'Content">' + '  <div class="overlayContainer">' + '    <div class="close"></div>' + '    <div class="content">' + '      <div class="video"></div>' + '    </div>' + '  </div>' + '</div>'
                    );
                    $('body').append(oapi.content);
                }

                logger.info('init - prefix:%o content:%o', prefix, oapi.content);

                setDimensions();

                oapi.content.show();
                oapi.background.show();

                $(window).off('.overlay').on('resize.overlay', _.debounce(function(e) {
                    oapi.resize();
                }, 200));

                oapi.content.find('.close').off('.overlay').on('click.overlay', function() {
                    oapi.close(true);
                });
            };

            oapi.initNextup = function() {
                if (!videoNextUp) {
                    videoNextUp = new wimbledonCore.VideoNextUp();
                }
                videoNextUp.init(curVideoId, this.content);
            };

            var setDimensions = function() {
                windowWidth = $(window).width();
                windowHeight = $(window).height();

                if (windowWidth > (desiredWidth + 100)) {
                    oapi.content.css({
                        "width": desiredWidth + "px",
                        "height": desiredHeight + "px",
                        "margin-left": "-" + (desiredWidth / 2) + "px"
                    });

                    videoHeight = desiredHeight - 6;
                    videoWidth = desiredWidth - 6;
                } else {
                    var calcWidth = windowWidth - 40;
                    var calcHeight = Math.round((calcWidth / 16) * 9) + 3;
                    if (calcHeight > (windowHeight - 84)) {
                        calcHeight = windowHeight - 84;
                        calcWidth = 16 * calcHeight / 9;
                        oapi.content.css({
                            "width": calcWidth + "px",
                            "height": calcHeight + "px",
                            "margin-left": "-" + (calcWidth / 2) + "px"
                        });
                        videoHeight = calcHeight - 6;
                        videoWidth = calcWidth - 6;
                    } else {
                        oapi.content.css({
                            "width": calcWidth + "px",
                            "height": calcHeight + "px",
                            "margin-left": "-" + (calcWidth / 2) + "px"
                        });
                        videoHeight = calcHeight - 6;
                        videoWidth = calcWidth - 6;
                    }
                }
            }

            oapi.loadLivit = function(videoId, videoTitle, videoData) {
                this.setPlayerType(_playerTypes.livit);
                var lvhtml = '<iframe width="' + videoWidth + '" height="' + videoHeight + '" border=0 src="' + videoData.url + '" />';
                this.content.find('.video').html(lvhtml);
            }

            // +id+ : Brightcove ID of video to load and play
            oapi.loadBrightcove = function(videoId, vidTitle) {
                this.setPlayerType(_playerTypes.brightcove);
                var playerId = "f55f0e43-a86b-4a11-bd26-bb30da5f78ff";
                if (typeof preroll !== 'undefined' && preroll) {
                    playerId = "1b830028-724a-415a-b732-e96d0d277647";
                }

                var bcHtml = '<video id="wimbledonPlayer" data-account="3506358525001" data-player="' + playerId + '" data-embed="default" data-video-id="' + videoId + '" class="video-js" controls></video>';
                this.content.find('.video').html(bcHtml);

                $.getScript('//players.brightcove.net/3506358525001/' + playerId + '_default/index.min.js', function() {
                    var myPlayer = videojs('wimbledonPlayer');

                    var options = {
                        "deeplinking": false,
                        "url": "http://www.wimbledon.com/en_GB/news/media/" + videoId + ".html",
                        "services": {
                            "facebook": true,
                            "google": true,
                            "twitter": true,
                            "tumblr": true,
                            "pinterest": false,
                            "linkedin": true
                        }
                    };
                    myPlayer.social(options);
                    $('.video-js').css({
                        "height": videoHeight + 'px',
                        "width": videoWidth + 'px'
                    });
                });

                // metrics
                // store prop4 value before changing it
                var prop4 = s.prop4;
                s.prop4 = 'VOD';
                s.prop36 = vidTitle || videoId;
                s.linkTrackVars = 'prop4,prop36';
                measureApp('Video & Radio', 'Play', videoId);
                // restore prop4 value after we're done
                s.prop4 = prop4;
            }

            oapi.load = function(videoId, vidTitle, autoplay) {
                this.setPlayerType(_playerTypes.ecp);
                var html = '<section class="ecp-player">' + '<div id="wrapper_' + videoId + '" class="wim-ecp playerwrapperContainer"></div>' + '</section>';

                this.content.find('.video').html(html);

                this.content.find('.errorMsg').remove();

                var videoData = _videoStore[videoId];
                logger.info('load - VideoOverlay - id:%o data:%o', videoId, videoData);



                wimbledonCore.videoPlayer.load(videoId, {
                    videoData: videoData
                });

                curVideoId = videoId;

                // metrics
                // store prop4 value before changing it
                var prop4 = s.prop4;
                s.prop4 = 'VOD';
                s.prop36 = vidTitle || videoId;
                s.linkTrackVars = 'prop4,prop36';
                if (!autoplay){
                    measureApp('Video & Radio', 'Play', videoId);
                }
                else {
                    measureAutoVideo('Video & Radio', 'Play', videoId);
                }
                // restore prop4 value after we're done
                s.prop4 = prop4;
            }

            oapi.setPlayerType = function(type) {
                this.activePlayer = type;
                resize_selector = this.activePlayer === _playerTypes.brightcove ? '.video-js' : 'iframe';
            }

            oapi.resize = function() {
                if (this.content.is(":visible")) {
                    setDimensions();
                    if (resize_selector != 'iframe') {
                        this.content.find(resize_selector).css({
                            "height": videoHeight + 'px',
                            "width": videoWidth + 'px'
                        });
                    }
                }
            }

            oapi.close = function(userAction) {
                this.background.hide();
                this.content.hide();
                wimbledonCore.videoPlayer.dispose(curVideoId);
                this.content.find('.video').html('');
                $(window).off('.overlay');

                curVideoId = undefined;

                if (videoNextUp) {
                    videoNextUp.cancel();
                }
            }

            oapi.curId = function() {
                return curVideoId;
            }

            oapi.showError = function(msg) {
                this.content.find('.content').prepend('<div class="errorMsg">' + msg + '</div>');
            }

            oapi.init();

            return oapi;
        }

        /**
         * manage the video inline element
         * @param content - the holding content element
         * @param id - video id
         * @param preroll - true/false whether a preroll should play before video
         */
        var VideoInline = function(content, id, preroll) {
            var curVideoId;

            var oapi = {};
            oapi.content = content;
            oapi.video = oapi.content.find('.video');

            oapi.init = function() {
                // create elements if they don't exist
                if (oapi.video.find('.ecp-player').length != 0) {
                    oapi.video.find('.ecp-player').remove();
                }

                var html = '<section class="ecp-player">' + '<div id="wrapper_' + id + '" class="wim-ecp playerwrapperContainer"></div>' + '</section>';
                oapi.video.append(html);

                logger.info('init - content:%o', oapi.content);
            };

            oapi.initNextup = function() {
                if (!videoNextUp) {
                    videoNextUp = new wimbledonCore.VideoNextUp();
                }
                videoNextUp.init(curVideoId, this.content);
            };

            oapi.load = function(videoId, vidTitle) {
                var videoData = _videoStore[videoId];
                logger.info('load - VideoInline - id:%o data:%o', videoId, videoData);

                wimbledonCore.videoPlayer.load(videoId, {
                    videoData: videoData
                });

                curVideoId = videoId;

                // metrics
                // store prop4 value before changing it
                var prop4 = s.prop4;
                s.prop4 = 'VOD';
                s.prop36 = vidTitle || videoId;
                s.linkTrackVars = 'prop4,prop36';
                measureApp('Video & Radio', 'Play', videoId);
                // restore prop4 value after we're done
                s.prop4 = prop4;
            }

            oapi.resize = function() {
                if (this.content.is(":visible")) {
                    setDimensions();
                    $('.video-js').css({
                        "height": videoHeight + 'px',
                        "width": videoWidth + 'px'
                    });
                }
            }

            oapi.complete = function(msg) {
                this.content.find('.posterWrapper').show();
                this.content.find('.ecp-player').hide();
            }

            oapi.curId = function() {
                return curVideoId;
            }

            oapi.showError = function(msg) {
                this.content.find('.content').prepend('<div class="errorMsg">' + msg + '</div>');
            }

            oapi.close = function() {
                wimbledonCore.videoPlayer.dispose(curVideoId);
                $('[data-video-id="' + curVideoId + '"]').find('.posterWrapper').show();
                $('[data-video-id="' + curVideoId + '"]').find('.ecp-player').remove();

                curVideoId = undefined;
            }

            oapi.init();

            return oapi;
        }

        // depends on relatedcontent.js library
        // along with event specific relatedcontent.wim.js extension
        var RelatedContentComponent = function(elem) {
            var rc = {};

            rc.element = elem;

            rc.render = function() {
                var type = rc.element.attr('data-type');
                var id = rc.element.attr('data-id');
                var limit = 12;
                if (type === 'tag') {
                    id = rc.element.attr('data-id').split(',');
                    limit = 6;
                }
                rc.list = new RelatedContent.List({
                    container: rc.element,
                    id: id,
                    limit: limit,
                    layout: 'list'
                });

                rc.list.load();
            }

            return rc;
        }

        var stopPlayingVideo = function() {
            if (inline && inline.curId()) {
                inline.close();
            }

            if (overlay && overlay.curId()) {
                overlay.close();
            }
        }

        api.loadGallery = function(options) {
            var logger = new eventsCore.util.Logger('ComponentGallery');
            _.defaults(options, _gallery_defaults);

            if (options.container !== undefined && options.container !== '' && options.path !== undefined && options.path !== '') {
                if (_types[options.type] === _types.photo) {
                    loadPhotoGallery(options.container, options.path, _platforms[options.platform] || _platforms[_gallery_defaults.platform]);
                } else if (_types[options.type] === _types.video) {
                    loadVideoGallery(options.container, options.path, _platforms[options.platform] || _platforms[_gallery_defaults.platform]);
                }
            }
        }

        api.setVideoOverlay = function(options) {
            if (typeof options === 'undefined') {
                options = {};
            }
            _.defaults(options, { prefix: 'overlay', preroll: false });

            return new VideoOverlay(options.prefix, options.preroll);
        };

        /**
         * open video overlay component
         */
        api.openVideoOverlay = function(id, title, options) {
            logger.info('openVideoOverlay - curId:%o id:%o', getCurrentVideo(), id);
            if (getCurrentVideo() == id) {
                return false;
            }

            if (typeof options === 'undefined') {
                options = {};
            }
            _.defaults(options, { prefix: 'overlay', preroll: false });

            stopPlayingVideo();

            overlay = new VideoOverlay(options.prefix, options.preroll);

            logger.info('openVideoOverlay - urlParam:%o', eventsCore.util.getUrlParam('player'));

            if (options.player) {
                switch(options.player) {
                    case 'brightcove':
                        overlay.loadBrightcove(id, title);
                        break;
                    case 'livit':
                        overlay.loadLivit(id, title, options.data);
                        break;
                    default:
                        overlay.load(id, title);
                        break;
                }
            } else if (!eventsCore.util.getUrlParam('player')) {
                switch(window.videoPlayerPlatform) {
                    case 'brightcove':
                        overlay.loadBrightcove(id, title);
                        break;
                    case 'ecp':
                    default:
                        overlay.load(id, title);
                        break;
                }
            } else {
                switch(eventsCore.util.getUrlParam('player')) {
                    case 'brightcove':
                        overlay.loadBrightcove(id, title);
                        break;
                    case 'ecp':
                    default:
                        overlay.load(id, title);
                        break;
                }
            }

            if (options.nextup) {
                overlay.initNextup();
            }
        };

        /**
         * open video inline
         *  - developed based on new news article template, may need expansion to other areas
         *  - does not prevent multiple videos from being played, needs to, to prevent conflicts in global inline element
         */
        api.openVideoInline = function(id, title, options) {
            var element = $('[data-video-id="' + id + '"]');

            if (typeof options === 'undefined') {
                options = {};
            }
            _.defaults(options, { prefix: 'inline', preroll: false });

            if (inline && inline.curId() != id) {
                stopPlayingVideo();
            } else if (inline && inline.curId() == id) {
                //ignore since loading same video as already loaded
                logger.info('openVideoInline - ignore click');
                return;
            }

            inline = new VideoInline(element, id, options.preroll);

            logger.info('openVideoInline - id:%o title:%o', id, title);

            element.find('.errorMsg').remove();
            element.find('.posterWrapper').hide();

            inline.load(id, title);

            if (options.nextup) {
                inline.initNextup();
            }
        };

        /**
         * open video inline from the video gallery
         *  - first checks if inline component exist and disposes of the matching video player
         */
        api.openVideoInlineGallery = function(elem, id, title, options, handler) {
            logger.info('openVideoInlineGallery - elem:%o', elem);

            if (typeof options === 'undefined') {
                options = {};
            }
            _.defaults(options, { prefix: 'inline', preroll: false });

            logger.info('openVideoInlineGallery - id:%o title:%o', id, title);

            if (inline && inline.curId() != id) {
                stopPlayingVideo();
            } else if (inline && inline.curId() == id) {
                //ignore since loading same video as already loaded
                logger.info('openVideoInlineGallery - ignore click');
                return;
            }

            if (handler) {
                completeHandler = handler;
            }

            inline = new VideoInline($(elem), id, options.preroll);

            inline.load(id, title);

            if (options.nextup) {
                inline.initNextup();
            }
        };

        api.addVideoData = function(id, data) {
            //logger.info('addVideoData - id:%o data:%o', id, data);
            if (_videoStore[id] === undefined) {
                _videoStore[id] = data;
            }
        };

        api.statChartsNavigation = function(container) {
            var container = $(container);
            var tbl = container.find('.resultsTable');
            var controls = container.find('.tableControl');

            // ensure table has 'first' so we're only showing first half
            if (!tbl.hasClass('first')) {
                tbl.removeClass('second').removeClass('third').addClass('first');
                controls.find('.tc-pager-link').removeClass('active');
                controls.find('.tc-pager-item:eq(0) a').addClass('active');
            }

            // clicking previous arrow
            controls.find('.tc-left').on('click', function(e) { //prev
                e.preventDefault();
                // update pager
                controls.find('.tc-pager-link').removeClass('active');

                // select first
                if (tbl.hasClass('second')) {
                    tbl.removeClass('second').removeClass('third').removeClass('fourth').addClass('first');
                    controls.find('.tc-pager-link:eq(0)').addClass('active');
                }
                // select second
                else if (tbl.hasClass('third') || (tbl.hasClass('first') && $('.tc-pager').hasClass('two'))) {
                    tbl.removeClass('first').removeClass('third').removeClass('fourth').addClass('second');
                    controls.find('.tc-pager-link:eq(1)').addClass('active');
                }
                // select third
                else if (tbl.hasClass('fourth') || (tbl.hasClass('first') && $('.tc-pager').hasClass('three'))) {
                    tbl.removeClass('first').removeClass('second').removeClass('fourth').addClass('third');
                    controls.find('.tc-pager-link:eq(2)').addClass('active');
                }
                // select fourth
                else if (tbl.hasClass('first') && $('.tc-pager').hasClass('four')) {
                    tbl.removeClass('first').removeClass('second').removeClass('third').addClass('fourth');
                    controls.find('.tc-pager-link:eq(3)').addClass('active');
                }
            });

            //clicking next arrow
            controls.find('.tc-right').on('click', function(e) {
                e.preventDefault();
                // update pager
                controls.find('.tc-pager-link').removeClass('active');

                // select first
                if (tbl.hasClass('fourth') || (tbl.hasClass('second') && $('.tc-pager').hasClass('two')) || (tbl.hasClass('third') && $('.tc-pager').hasClass('three'))) {
                    tbl.removeClass('second').removeClass('third').removeClass('fourth').addClass('first');
                    controls.find('.tc-pager-link:eq(0)').addClass('active');
                }
                // select second
                else if (tbl.hasClass('first')) {
                    tbl.removeClass('first').removeClass('third').removeClass('fourth').addClass('second');
                    controls.find('.tc-pager-link:eq(1)').addClass('active');
                }
                // select third
                else if (tbl.hasClass('second')) {
                    tbl.removeClass('first').removeClass('second').removeClass('fourth').addClass('third');
                    controls.find('.tc-pager-link:eq(2)').addClass('active');
                }
                // select fourth
                else if (tbl.hasClass('third') && $('.tc-pager').hasClass('four')) {
                    tbl.removeClass('first').removeClass('second').removeClass('third').addClass('fourth');
                    controls.find('.tc-pager-link:eq(3)').addClass('active');
                }
            });

            /*controls.find('.tc-pager-item').on('click', function(e) {
			var link = $(this).find('.tc-pager-link');
			if(!link.hasClass('active')) {
			  var i = link.data('slide-index');
			  controls.find('.tc-pager-link.active').removeClass('active');
			  link.addClass('active');
			  switch(i) {
				case 0:   tbl.removeClass('second').removeClass('third').addClass('first');
						  break;
				case 1:   tbl.removeClass('first').removeClass('third').addClass('second');
						  break;
				case 2:   tbl.removeClass('first').removeClass('second').addClass('third');
						  break;
			  }
			}
		  }).find('.tc-pager-link').on('click', function(e) {
			e.preventDefault();
		  });*/

            controls.find('.tc-pager-link').on('click', function(e) {
                e.preventDefault();
            });
        }

        api.loadRelatedContentComponent = function(selector) {
            selector.each(function() {
                var comp = new RelatedContentComponent($(this));
                comp.render();
            });
        }

        api.stopInlineVideo = function(id) {
            if (inline && inline.curId() == id) {
                stopPlayingVideo();
            }
        }

        return api;
    };

    wimbledonCore.component = new Component();

}(jQuery, window.wimbledonCore));
